import styled from "styled-components";
import { colors } from "../../../../styles/colors";

export const CardContainer = styled.div`
  background-color: ${colors.lightGray};
  border-radius: 9px;
  padding: 20px;
  position: relative;

  .options-container {
    max-height: 210px;
    overflow-y: auto;
    position: relative;
    direction: ltr;
    padding-right: 14px;

    .card-icon {
      width: 15px;
      height: 15px;
      margin-right: auto;
      display: block;
      margin-bottom: 10px;
    }

    &::-webkit-scrollbar {
      width: 5px;

      &-track {
        background: ${colors.white};
      }

      &-thumb {
        background: ${colors.blueGray};
        border-radius: 8.67px;

        &:hover {
          background: ${colors.blueGray};
        }
      }
    }
  }
`;
